var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src !== '')?_c('el-image',{staticStyle:{"width":"50px","height":"50px"},attrs:{"fit":"contain","src":_vm.src,"preview-src-list":_vm.srcList}},[_c('div',{attrs:{"slot":"error"},slot:"error"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }